import styled from "styled-components"

export const Wrapper = styled.footer`
  padding: 3.5rem 0 2rem;
  border-top: 1px solid var(--line);
  background: var(--paper);
  font-size: 0.95rem;
`

export const Grid = styled.div`
  display: grid;
  gap: 2rem;
  @media (min-width: 768px) {
    grid-template-columns: 1.4fr 1fr 1fr;
    gap: 3rem;
  }
`

export const Column = styled.div`
  h2 {
    margin-bottom: 0.75rem;
    font-family: var(--font-body);
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0;
    color: var(--ink);
  }
  p {
    margin: 1rem 0 0;
    max-width: 38ch;
    color: var(--muted);
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    margin-bottom: 0.5rem;
    color: var(--muted);
  }
`

export const Brand = styled.a`
  display: inline-block;
  img {
    width: 154px;
    height: auto;
  }
`

export const Social = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  a {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--text);
    text-decoration: none;
    &:hover {
      color: var(--navy);
      text-decoration: underline;
    }
  }
  img {
    width: 28px;
    height: 28px;
  }
`

export const Legal = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  margin-top: 2.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--line);
  color: var(--muted);
  a {
    color: var(--muted);
    text-decoration: none;
    &:hover {
      color: var(--navy);
      text-decoration: underline;
    }
  }
`
